import { Ajax, CrudApiBase } from "../infra";
import { Record, RecordListItem } from "../../model";

/**
 * Provides CRUD access to records.
 */
export class Records extends CrudApiBase<Record, RecordListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/records";

  constructor(ajax: Ajax) {
    super(ajax);
  }

  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(): Record {
    return {
      attachments: [],
      usecase: {
        data: {},
      },
    };
  }

  /**
   * Returns all distinct record types from all  records.
   * @returns A Promise with result data array.
   */
   public getRecordTypes(): Promise<string[]> {
    return this.ajax.getJSON(`${this.baseUrl}/recordTypes`);
  }

  /**
   * Returns all records for the entity.
   * @param entityType Entity type of the business object.
   * @param entityId Optional id for the business object.
   */
  public getForEntity(entityType: "account" | "employment" | string, entityId: string = null): Promise<Record[]> {
    if (entityId) {
      return this.ajax.getJSON(`${this.baseUrl}/${entityType}/${entityId}`);
    }
    else
    {
      return this.ajax.getJSON(`${this.baseUrl}/${entityType}`);
    }
  }

  /**
   * Gets the upload URL for attachment files.
   * This URL is compatible with the HTML forms standard multipart/form-data upload.
   * @param entityType Entity type of the business object.
   * @param entityId Optional id for the business object.
   * @returns The URL for multipart/form-data upload
   */
  public getRecordUploadUrl(entityType: "account" | "employment" | string, entityId: string = null): string {
    if (entityId) {
      return `${this.ajax.getServerAddress()}${this.baseUrl}/${entityType}/${entityId}/files`;
    }
    else
    {
      return `${this.ajax.getServerAddress()}${this.baseUrl}/${entityType}/files`;
    }
  }
}
